/**
 * Google Analytics event helper. Only sends events in production when gtag is available.
 */
export function trackEvent(eventName, eventParams = {}) {
  if (typeof window === 'undefined') return;
  const hostname = window.location && window.location.hostname;
  // Only send events when not running on localhost
  if (!hostname || hostname === 'localhost') return;

  if (typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, eventParams);
}
